import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { Subscription, Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { ModalCodigoConductaComponent } from 'src/app/components/core/layouts/modal-codigo-conducta/modal-codigo-conducta.component';
// tslint:disable-next-line:max-line-length
import { ModalConfirmacionSolicitudComponent } from 'src/app/components/core/layouts/modal-confirmacion-solicitud/modal-confirmacion-solicitud.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompletaInformacionService } from '../completa-informacion/completa-informacion.service';
import { PagoParafiscalService } from './pago-parafiscal.service';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
// tslint:disable-next-line:max-line-length
import { ConfirmarRespuestaModel, TipoConfirmacionModalType, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';
import { TipoRnt } from 'src/app/shared/enumeraciones/tipo-rnt.enum';
import { TipoPrestador } from 'src/app/shared/enumeraciones/tipo-prestador.enum';
import { AuthService } from 'src/app/shared/services/auth.service';
import { AyudasService } from 'src/app/components/contenido/containers/ayudas/ayudas.service';
import { ConfirmeValidators } from 'src/app/shared/directives/validators/confirme-validators';

@Component({
	selector: 'app-pago-parafiscal',
	templateUrl: './pago-parafiscal.component.html',
	styleUrls: ['./pago-parafiscal.component.scss']
})
export class PagoParafiscalComponent implements OnInit {
	@Output()
	pasoActual: EventEmitter<number> = new EventEmitter();

	pagoParaficalForm: FormGroup;
	datoSolicitudSharedModel: DatoSolicitudSharedModel;
	rnt: RNTPrestadorEntry;
	subscription: Subscription;
	tope: number;
	desc_tope: number;
	boton_atras: string;
	boton: string;
  textoPagoAportesParafiscales: string = "";

	constructor(private formBuilder: FormBuilder, private dataSharedService: DataSharedService, private router: Router,
		private modalService: NgbModal, private completaInformacionService: CompletaInformacionService,
		private pagoParafiscalService: PagoParafiscalService, private authService: AuthService, public ayudaService: AyudasService) {
		this.pagoParaficalForm = formBuilder.group({
			ingreso_anual: ['', [Validators.required, ConfirmeValidators.numberNegativeValidator, Validators.max(999999999999999999)]],
			pago_parafiscal: ['', Validators.required]
		});
	}

	ngOnInit() {
		this.boton = 'Siguiente';
		this.boton_atras = 'Atrás';
		this.pasoActual.emit(5);
		this.subscription = this.dataSharedService.data$.subscribe(dataShared => {
			this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
			this.rnt = this.datoSolicitudSharedModel.data as RNTPrestadorEntry;
		});
		this.pagoParafiscalService.getTope({ sub_categoria_id: this.rnt.sub_categoria_id }).subscribe(resultado => {
			if (resultado.result) {
				this.tope = resultado.data.tope;
				this.desc_tope = resultado.data.ingresos; // resultado.data.tope;
			}
		});
    this.pagoParafiscalService.getParametro({
			parametro_id: 'TEXTO_PAGO_APORTES_PARAFISCALES',
			agrupacion: 'PAGO_APORTES_PARAFISCALES',
			auxiliar: '1'
		}).subscribe(resultado => {
      if (resultado.result) {
        this.textoPagoAportesParafiscales = resultado.data;
      }
    });
	}

	onPagoParafiscal() {
		this.rnt.paso = 5;
		if (this.pagoParaficalForm.value.pago_parafiscal) {
			this.completaInformacionService.update({
				...this.rnt,
				total_ventas: this.pagoParaficalForm.value.ingreso_anual,
				supera_pago_parafiscales: this.pagoParaficalForm.value.pago_parafiscal
			}).subscribe(resultado => {
				if (resultado.result) {
					this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
						data: {
							...this.rnt, total_ventas: this.pagoParaficalForm.value.ingreso_anual,
							supera_pago_parafiscales: this.pagoParaficalForm.value.pago_parafiscal
						},
						tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
						tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt
					});
					this.router.navigate(['/solicitud/fontur']);
				}
			});
		} else {
			const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
			const confirmarRespuesta = {} as ConfirmarRespuestaModel;
			confirmarRespuesta.tipoConfirmacionModalType = TipoConfirmacionModalType.Confirmacion;
			confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
			confirmarRespuesta.message = '¿Está seguro que desea finalizar la solicitud?';
			modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
			modalRef.result.then((resultadoModal) => {

				this.completaInformacionService.update({
					...this.rnt,
					total_ventas: this.pagoParaficalForm.value.ingreso_anual,
					supera_pago_parafiscales: this.pagoParaficalForm.value.pago_parafiscal
				}).subscribe(resultado => {
					if (resultado.result) {
						this.pagoParafiscalService.delete(this.rnt).subscribe(resultadoMigra => {
							if (resultadoMigra.result) {
								this.completaInformacionService.sendNotificar({
									...this.rnt,
									total_ventas: this.pagoParaficalForm.value.ingreso_anual,
									supera_pago_parafiscales: this.pagoParaficalForm.value.pago_parafiscal
								}).subscribe(resultadoNotifica => {
									if (resultadoNotifica.result) {
										const modalFinalizar = this.modalService.open(ModalConfirmacionSolicitudComponent, { centered: true });
										modalFinalizar.componentInstance.mensaje = resultadoNotifica.data;
										modalFinalizar.result.then(() => {
											this.router.navigate(['/mis-establecimientos']);
										}).catch(() => {
											this.router.navigate(['/mis-establecimientos']);
										});
									}
								});
							}
						});

					}
				});
			});
		}
	}

	onChangeIngreso() {
		this.pagoParafiscalService.getValidarIngreso(
			{
				ingresos: this.pagoParaficalForm.value.ingreso_anual,
				tope: this.tope
			}).subscribe(resultado => {
				if (resultado.result) {
					if (resultado.data) {
						this.boton = 'Siguiente';
						this.boton_atras = 'Atrás';
					} else {
						this.boton = 'Finalizar';
						this.boton_atras = 'Revisar';
					}
					this.pagoParaficalForm.patchValue({ pago_parafiscal: resultado.data });
				}
			});

	}

	onRegresarPaso(): void {
		const rnt: RNTPrestadorEntry = {
			...this.rnt,
			tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud
		};
		this.completaInformacionService.update(rnt).subscribe(resultado => {
			if (resultado.result) {
				this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
					data: { ...this.rnt },
					tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
					tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
					estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud
				});
				if (this.pagoParaficalForm.value.pago_parafiscal || !this.pagoParaficalForm.value.ingreso_anual) {
					this.router.navigate(['/solicitud/codigo-conducta']);
				} else {
					if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Inmuebles) {
						this.router.navigate(['solicitud/completa-informacion-inmueble']);
					} else {
						if (this.datoSolicitudSharedModel.tipo_rnt !== TipoRnt.Guia) {
							this.router.navigate(['solicitud/completa-informacion']);
						} else {
							this.router.navigate(['solicitud/completa-informacion-guia']);
						}
					}
				}
			}
		});
	}
}
